var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 35,
    viewBox: "0 0 19 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13148_269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.0498 33.6035C3.30296 34.398 2.08663 34.3995 1.34766 33.6025C0.617135 32.8145 0.618136 31.5344 1.34766 30.7422V30.7412L13.6182 17.501L1.34766 4.26855C0.616501 3.48002 0.618802 2.19967 1.34668 1.39844L1.34766 1.39746C2.08689 0.600221 3.29877 0.602035 4.0498 1.39551L4.05078 1.39746L17.6514 16.0645C18.0105 16.4519 18.2002 16.9624 18.2002 17.5C18.2002 18.0376 18.0105 18.5481 17.6514 18.9355L4.05078 33.6025L4.0498 33.6035Z",
    fill: "#BABEC1",
    stroke: "#BABEC1",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13148_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyChevronRight);
export default __webpack_public_path__ + "static/media/grey-chevron-right.e1481dc70648e8eec15f2c7c9c396951.svg";
export { ForwardRef as ReactComponent };